// The name of the storage location where we'll cache the Encoded Session Attributes value
export const STORAGE_LOCATION = 'google_session_attributes_encoded'

export const INTEGRATION_FIELD_NAME = 'session_attributes_encoded'

export const DESTINATION_NAME = 'Google Ads Conversions'